import React, { useState } from 'react'
import { IconButton, TextField, Button } from '@material-ui/core'
import { Add, Close, Edit, Remove, Save } from '@material-ui/icons'
import { IAllowedCustomer } from '@vacinas-net/shared'
import { mainTheme } from '../../utils/mainTheme'
import { useListContext, useNotify } from 'react-admin'
import customHttpClient from '../CustomHttpClient'
import { apiUrl } from '../AppDataProvider'

const EditAllowedCustomerVouchersInline = (props: {
  allowedCustomer: IAllowedCustomer & {
    usedVouchersAmount?: number
    campaignId?: string
  }
  disabled?: boolean
}) => {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState(props.allowedCustomer.givenVoucherAmount)

  const notify = useNotify()
  const list = useListContext()

  const patchAllowedCustomerVouchers = async () => {
    setLoading(true)
    try {
      await customHttpClient(`${apiUrl}/campaign/allowed-customer`, {
        body: JSON.stringify({
          campaignId: props.allowedCustomer.campaignId,
          document: props.allowedCustomer.document,
          givenVoucherAmount: value,
        }),
        method: 'PATCH',
      })
      list.refetch()
      setOpen(false)
    } catch (error) {
      notify(`Erro ao atualizar vales: ${error}`, 'error')
    } finally {
      setLoading(false)
    }
  }

  const decreaseCounter = () => {
    value! - 1 > 0 && setValue(value - 1)
  }

  const increaseCounter = () => {
    setValue(value! + 1)
  }

  return (
    <div style={{ position: 'relative' }}>
      <IconButton
        onClick={() => {
          setOpen(!open)
        }}
        disabled={props.disabled}
        size="small"
      >
        <Edit />
      </IconButton>
      {open && (
        <div
          style={{
            display: 'flex',
            background: '#ebe4ee',
            position: 'absolute',
            top: -74,
            right: -18,
            zIndex: 3,
            borderTopLeftRadius: mainTheme.spacing(1),
            borderTopRightRadius: mainTheme.spacing(1),
            padding: mainTheme.spacing(2),
          }}
        >
          <IconButton onClick={() => setOpen(false)} size="small">
            <Close />
          </IconButton>
          <IconButton
            style={{
              marginLeft: mainTheme.spacing(1),
            }}
            onClick={decreaseCounter}
            size="small"
          >
            <Remove />
          </IconButton>
          <div>
            <TextField
              style={{
                width: 48,
                marginLeft: mainTheme.spacing(2),
                marginRight: mainTheme.spacing(2),
              }}
              value={value}
              size="small"
              onChange={(ev) => {
                setValue(parseInt(ev.target.value))
              }}
              inputProps={{
                min: 1,
              }}
              type="number"
            />
          </div>
          <IconButton onClick={increaseCounter} size="small">
            <Add />
          </IconButton>
          <Button
            style={{
              marginLeft: mainTheme.spacing(1),
            }}
            startIcon={<Save />}
            onClick={() => patchAllowedCustomerVouchers()}
            size="small"
            variant="outlined"
            disabled={
              value === props.allowedCustomer.givenVoucherAmount || loading
            }
          >
            Salvar
          </Button>
        </div>
      )}
    </div>
  )
}

export default EditAllowedCustomerVouchersInline
